import { useState, useEffect } from 'react'
import { colors, fonts } from '../components/UI'

const PREFS_KEY = 'tic_notification_prefs'

const DEFAULT_PREFS = {
  billsDueSoon: true,
  paydayReminder: true,
  lowBalance: true,
  goalMilestone: true,
}

function Toggle({ on, onChange }) {
  return (
    <button onClick={() => onChange(!on)} style={{ width: '44px', height: '24px', borderRadius: '12px', border: 'none', cursor: 'pointer', background: on ? colors.gold : 'rgba(255,255,255,0.12)', position: 'relative', flexShrink: 0, transition: 'background 0.2s' }}>
      <div style={{ width: '18px', height: '18px', borderRadius: '50%', background: '#fff', position: 'absolute', top: '3px', left: on ? '23px' : '3px', transition: 'left 0.2s' }} />
    </button>
  )
}

function PrefItem({ emoji, title, sub, prefKey, prefs, setPrefs, last }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 16px', borderBottom: last ? 'none' : '1px solid rgba(255,255,255,0.06)' }}>
      <div style={{ width: '38px', height: '38px', borderRadius: '10px', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>{emoji}</div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '14px', fontWeight: 600, color: colors.text }}>{title}</div>
        <div style={{ fontSize: '13px', fontWeight: 500, color: colors.muted, marginTop: '2px', lineHeight: 1.5 }}>{sub}</div>
      </div>
      <Toggle on={prefs[prefKey]} onChange={v => setPrefs(p => {
        const updated = { ...p, [prefKey]: v }
        localStorage.setItem(PREFS_KEY, JSON.stringify(updated))
        return updated
      })} />
    </div>
  )
}

export default function NotificationsPage() {
  const [prefs, setPrefs] = useState(DEFAULT_PREFS)

  useEffect(() => {
    try {
      const stored = localStorage.getItem(PREFS_KEY)
      if (stored) setPrefs({ ...DEFAULT_PREFS, ...JSON.parse(stored) })
    } catch {}
  }, [])

  return (
    <div style={{ paddingBottom: '40px' }}>
      <div style={{ padding: '18px 20px 16px' }}>
        <div style={{ fontFamily: fonts.heading, fontWeight: 800, fontSize: '22px', color: colors.text, letterSpacing: '-0.01em' }}>Notifications</div>
        <div style={{ fontSize: '13px', fontWeight: 500, color: colors.muted, marginTop: '4px' }}>In-app alerts shown when you open the tracker.</div>
      </div>

      <div style={{ padding: '0 16px' }}>

        {/* Info banner */}
        <div style={{ background: 'rgba(74,143,232,0.08)', border: '1px solid rgba(74,143,232,0.2)', borderRadius: '14px', padding: '12px 16px', marginBottom: '20px', display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
          <span style={{ fontSize: '18px', flexShrink: 0 }}>🔔</span>
          <div style={{ fontSize: '13px', fontWeight: 500, color: colors.muted, lineHeight: 1.6 }}>
            Notifications appear in the bell icon on your home screen. Toggle each one on or off below.
          </div>
        </div>

        {/* Bills */}
        <div style={{ fontSize: '12px', fontWeight: 700, letterSpacing: '0.07em', color: colors.muted, marginBottom: '8px' }}>BILLS</div>
        <div style={{ background: colors.card, border: '1px solid rgba(255,255,255,0.06)', borderRadius: '16px', overflow: 'hidden', marginBottom: '20px' }}>
          <PrefItem emoji="📅" title="Bills due soon" sub="Alert when a bill is due within 7 days" prefKey="billsDueSoon" prefs={prefs} setPrefs={setPrefs} last />
        </div>

        {/* Pay cycle */}
        <div style={{ fontSize: '12px', fontWeight: 700, letterSpacing: '0.07em', color: colors.muted, marginBottom: '8px' }}>PAY CYCLE</div>
        <div style={{ background: colors.card, border: '1px solid rgba(255,255,255,0.06)', borderRadius: '16px', overflow: 'hidden', marginBottom: '20px' }}>
          <PrefItem emoji="💰" title="Payday reminder" sub="Reminder to update account balances on payday" prefKey="paydayReminder" prefs={prefs} setPrefs={setPrefs} last />
        </div>

        {/* Safe to Spend */}
        <div style={{ fontSize: '12px', fontWeight: 700, letterSpacing: '0.07em', color: colors.muted, marginBottom: '8px' }}>SAFE TO SPEND</div>
        <div style={{ background: colors.card, border: '1px solid rgba(255,255,255,0.06)', borderRadius: '16px', overflow: 'hidden', marginBottom: '20px' }}>
          <PrefItem emoji="⚠️" title="Low balance warning" sub="Alert when Safe to Spend drops below £100" prefKey="lowBalance" prefs={prefs} setPrefs={setPrefs} last />
        </div>

        {/* Goals */}
        <div style={{ fontSize: '12px', fontWeight: 700, letterSpacing: '0.07em', color: colors.muted, marginBottom: '8px' }}>GOALS</div>
        <div style={{ background: colors.card, border: '1px solid rgba(255,255,255,0.06)', borderRadius: '16px', overflow: 'hidden', marginBottom: '20px' }}>
          <PrefItem emoji="🎯" title="Goal milestones" sub="Celebrate hitting 25%, 50%, 75% and 100% of a goal" prefKey="goalMilestone" prefs={prefs} setPrefs={setPrefs} last />
        </div>

      </div>
    </div>
  )
}
